export default {
  title: "Mis tickets",
  refresh: "Actualizar",
  create: "Crear",
  id: "ID del ticket",
  type: "Tipo",
  status: "Estado",
  createdAt: "Creado el",
  actions: "Acciones",
  detailTitle: "Detalles del ticket",
  email: "Correo electrónico",
  description: "Descripción",
  response: "Respuesta",
  noResponse: "Aún no hay respuesta",
  statusPending: "Pendiente",
  statusResolved: "Resuelto",
  statusClosed: "Cerrado",
};
